<template>
  <!-- 专题活动 -->
  <div class="events min-w">
    <div class="out">
      <div is='titlebox' :nav='nav'></div>
    </div>
    <div class="main-in">
      <div class="align-start box" :class="kind%2==0?'f-row-r':'f-row-l'" v-for="(items,kind) in list" :key='kind'>
        <img :src="$imgUrl+items.rawMap" :class="kind%2==0?'imgl':'imgr'"/>
        <ul class="wr1  f-row-b align-start" :class="kind%2==0?'bg-red color-white':'b-1'">
          <div v-if='kind%2==0'></div>
          <div class="box-in font-1">
            <div class="font-0 mb-2 mt-6">{{ items.title }}</div>
            <li v-for="(item,ind) in items.activityItems" :key='ind' class="pinter"
                @click.stop="$util.goPage('newDetail',15,item.id)">{{ item.title ? item.title : '' }}
            </li>
            <div class="more1 f-row-c pinter" @click.stop="$util.goPage('news',15,items.id)">
              查看更多<img src='../../assets/img/party/more2.png' v-if='kind%2==0'/>
              <img src='../../assets/img/party/more1.png' v-else/>
            </div>
          </div>
          <div v-if='kind%2==1'></div>
        </ul>

      </div>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: [
        {
          label: '党建服务',
          path: '/partyService',
          type: 14
        },
        {
          label: '专题活动',
          path: '/Events',
          type: 15
        }
      ],
      list: [],
      total: 0,
      pageNo: 1,
      pageSize: 4,
    };
  },

  created() {
    this.getActivity()
  },

  methods: {
    getActivity() {//专题活动
      var param = {
        pageNo: this.pageNo,//分页
        pageSize: this.pageSize,
      }
      this.$get('/web/home/newActList', param).then(res => {
        this.list = res.result.records;
        this.total = res.result.total
      })
    },
    handleSizeChange(val) {
      this.$util.goTop()
      this.pageSize = val;
      this.getActivity();
    },
    handleCurrentChange(val) {
      this.$util.goTop()
      this.pageNo = val;
      this.getActivity();
    },
  },
};
</script>

<style lang="scss" scoped>
.events {
  background-color: #fff;
 margin: auto;

  .out {
    max-width: 1300px;
    margin: auto;
  }

  .pages {
    text-align: center;
    margin: 30px auto 30px;
  }
}

.box {
  width: 100%;
  position: relative;
  padding-top: 118px;
  margin-bottom: 25px;

  .wr1 {
    width: calc(100% - 132px);
    min-height: 425px;
    position: relative;

    .box-in {
      width: calc(100% - 529px);
      margin-right: 10px;

      li {
        padding: 10px 0px;
      }
    }
  }

  .imgl, .imgr {
    width: 651px;
    height: 434px;
    position: absolute;
    top: 80px;
    z-index: 2;
  }

  .imgl {
    left: 0px;
  }

  .imgr {
    right: 0px;
  }
}

.more1 {
  position: absolute;
  bottom: 37px;

  img {
    width: 34px;
    margin-left: 60px;
  }
}

.bg-red {
  background: #A62725;
}
</style>